<template>
    <div
            class="recurring-status-table loadable failable"
            :class="{loading: loading, failed: error}"
    >
        <template v-if="subscriptions !== null">
            <div class="table-wrapper">
                <table class="table">
                    <template v-if="subscriptions.length !== 0">
                        <thead>
                        <tr>
                            <th class="header" colspan="5">
                                {{$t('subscription.recurrency.header.active')}}
                            </th>
                        </tr>
                        <tr>
                            <th class="hidden">
                                {{$t('subscription.recurrency.next_payment.table.date')}}
                            </th>
                            <th class="hidden">
                                {{$t('subscription.recurrency.next_payment.table.card')}}
                            </th>
                            <th>
                                {{$t('subscription.recurrency.next_payment.table.subscription_plan')}}
                            </th>
                            <th>
                                {{$t('subscription.recurrency.next_payment.table.status')}}
                            </th>
                            <th>
                                {{$t('subscription.recurrency.next_payment.table.actions')}}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                                v-for="subscription in subscriptions"
                                :key="subscription.id"
                        >
                            <td class="hidden">
                                {{$d(new Date(subscription.next_scheduled_payment.date), 'short')}}
                            </td>
                            <td class="hidden">
                                {{subscription.user_credit_card.type}} XXXX{{subscription.user_credit_card.data.last_4_digits}}
                            </td>
                            <td>
                                {{subscription.next_scheduled_payment.purchase_option.data.subscription_plan.data.description}}
                            </td>
                            <td class="text-center">
                                {{$t(`subscription.recurrency.latest_payment.status.${subscription.latest_payment_status}`)}}
                            </td>
                            <td class="text-center">
                                <button
                                  v-if="subscription.active"
                                  :title="$t(`subscription.recurrency.view_payments`)"
                                  @click="loadPayments(subscription.id)"
                                >
                                  💳
                                </button>
                                <button
                                  v-if="subscription.active"
                                  class="cancel"
                                  :title="$t(`subscription.recurrency.cancel_subscription`)"
                                  @click="unsubscribeSubscription = subscription"
                                >
                                  ✖
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                    <template v-else>
                        <thead>
                        <tr>
                            <th class="header" colspan="4">
                                {{$t('subscription.recurrency.header.inactive')}}
                            </th>
                        </tr>
                        </thead>
                    </template>
                </table>
            </div>
        </template>
        <div class="loader-wrapper">
            <Spinner/>
        </div>
        <div class="failed-wrapper">
            <div>
                <div class="block">
                    <p>
                        {{$t('error')}}
                    </p>
                    <button
                            type="button"
                            @click.prevent="loadSubscriptions"
                    >
                        {{$t('retry')}}
                    </button>
                </div>
            </div>
        </div>

        <UnsubscribeModal
                v-if="unsubscribeSubscription"
                :subscription="unsubscribeSubscription"
                @updated="handleUnsubscribeUpdated"
                @cancel="unsubscribeSubscription = null"
        />
    </div>
</template>

<script>
    import Spinner from "./Spinner";
    import resources from './../resources';
    import UnsubscribeModal from "./UnsubscribeModal";
    import EventBus from "../eventbus";

    export default {
        components: {
            UnsubscribeModal,
            Spinner,

        },
        data(){
            return {
                subscriptions: null,
                loading: true,
                error: false,
                unsubscribeSubscription: null,
            };
        },
        mounted(){
          this.loadSubscriptions();
        },
        methods: {
            loadSubscriptions(){
                this.error = false;
                this.loading = true;

                resources.subscriptions.index({active: 1})
                    .then((response) => {
                        this.loading = false;
                        this.subscriptions = response.data.data;

                    }).catch(() => {
                    this.loading = false;
                    this.subscriptions = null;
                    this.error = true;
                })
            },
            loadPayments(subscription_id){
             EventBus.$emit('loadPayments', subscription_id);
            },
            handleUnsubscribeUpdated(){
                this.unsubscribeSubscription = null;
                this.loadSubscriptions();
            }
        },
    }
</script>

<style scoped lang="scss">
@import '../styles/variables';

.recurring-status-table{
    display: block;

  .table-wrapper{
    overflow-x: auto;
    overflow-y: hidden;
  
    th.header{
      background-color: $pallete_main_color;
      color: $pallete_clear_text_color;
      text-transform: uppercase;
      font-weight: bold;
      text-align: left;
    }
    
    td{
      font-size: .9em;
    
      &.text-center{
        text-align: center;
      }
    
      button{
        margin: 5px;
        padding: 5px 15px;
        border-radius: 3px;
        cursor: pointer;
        transition: background-color 200ms ease-in-out;
        font-size: 1.2em;
      
        &.cancel{
          background-color: $pallete_main_color;
          color: #ffffff;
        
          &:hover{
            background-color: #fd4872;
          }
        }
      }
    }
  }
  
  .failed-wrapper{
      text-align: center;
      padding: 1em;
  }

  .failed-wrapper, .loading-wrapper{
      min-height: 75px;
  }
}


@media(max-width: 640px){
  .hidden{
    display: none;
  }
}
@media(max-width: 480px){
  button{
    width: 100%;
  }
}
</style>